var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-unsorted",
  "use": "ring-icon-unsorted-usage",
  "viewBox": "0 0 4.969 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4.969 8\" id=\"ring-icon-unsorted\"><path d=\"M4.976 5.683L2.671 8h-.407L-.009 5.719l.472-.722L2.499 7.04l2.044-2.068zm0-3.366L2.671 0h-.407L-.009 2.281l.472.722L2.499.96l2.044 2.068z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id